import {Grid, FormControlLabel, FormControl, RadioGroup} from '@mui/material'
import WbRadioButton from '../../../components/common/WbRadioButton'
import {CHECK_IN_FREQUENCY_OPTIONS} from '../checkInFrequency'

export default function SelectFrequency({setFrequency, frequency}) {
  const handleFrequecyChange = val => setFrequency(parseInt(val))

  return (
    <>
      <Grid container>
        <Grid item lg={12} md={12} sm={12} xs={12} mt={4}>
          <h3>
            <strong>Set Frequency</strong>
          </h3>
        </Grid>
        <Grid item lg={12} md={12} sm={12} xs={12} mt={2} pl={1}>
          <FormControl>
            <RadioGroup value={frequency} name="radio-buttons-group">
              {CHECK_IN_FREQUENCY_OPTIONS.map(({value, label}) => (
                <FormControlLabel
                  key={value}
                  onChange={e => handleFrequecyChange(e.target.value)}
                  value={value}
                  control={<WbRadioButton />}
                  label={label}
                />
              ))}
            </RadioGroup>
          </FormControl>
        </Grid>
      </Grid>
    </>
  )
}
